import React, { useMemo } from "react"
import { Alert, Button, CircularProgress, Snackbar } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { useProducts } from "@/shared/hooks/useProducts"
import { useAuth } from "@/features/auth/context/AuthContext"
import { useFaviconLoader } from "@/shared/hooks/useFaviconLoader"

const GeneratingImagesIndicator: React.FC = () => {
  const { user } = useAuth()
  const { products } = useProducts(user?.uid ?? null)
  const generatingCount = useMemo(
    () => products.filter(p => !p.imageGenerated && !p.quotaExceeded && !p.generationFailed).length,
    [products]
  )
  const navigate = useNavigate()
  useFaviconLoader(generatingCount > 0)

  const handleView = () => {
    navigate("/my-listings")
  }

  if (generatingCount === 0) return null

  return (
    <Snackbar open anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
      <Alert
        icon={<CircularProgress size={16} color="inherit" />}
        severity="success"
        variant="filled"
        action={
          <Button color="inherit" size="small" onClick={handleView}>
            View
          </Button>
        }>
        Generating images ({generatingCount})
      </Alert>
    </Snackbar>
  )
}

export default GeneratingImagesIndicator
